export default class Settings {
    static APIURL = 'https://psi-hub-prod-api.azurewebsites.net/api/';
    // 'https://localhost:44381/api/'//local
    // 'https://psi-hub-dev-api.azurewebsites.net/api/' dev
    // 'https://psi-hub-prod-api.azurewebsites.net/api/' prod
    static ROLES = {
        ADMIN: '4b4dcdd7-72ba-4e3f-b44b-6ce5d4b17ffa'
    }
}
